import { React } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import CreateGroupModal from '../../../../common/components/CreateGroupModal';

const AddEmployeesModal = ({ group, isVisible, closeModal }) => {
  return (
    <CreateGroupModal
      closeModal={closeModal}
      isVisible={isVisible}
      heading='Add Employees'
      groupEmployees={group}
      isAddEmployeeToGroup
    />
  );
};

AddEmployeesModal.propTypes = {
  group: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
};
AddEmployeesModal.defaultProps = {
  group: {},
  isVisible: false,
  closeModal: _noop,
};

export default AddEmployeesModal;
